/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_DeviceInputs */

const th_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อุปกรณ์นี้`)
};

const en_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this device`)
};

const ja_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この端末`)
};

const zh_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本设备`)
};

const es_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este dispositivo`)
};

const pt_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este dispositivo`)
};

const id_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`perangkat ini`)
};

const fr_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cet appareil`)
};

const tl_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ang device na ito`)
};

const vi_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`thiết bị này`)
};

const ko_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 기기`)
};

const de_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dieses Gerät`)
};

const ru_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`это устройство`)
};

const tr_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bu cihaz`)
};

const it_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`questo dispositivo`)
};

const pl_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to urządzenie`)
};

const uk_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`цей пристрій`)
};

const hi_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह उपकरण`)
};

const ar_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الجهاز`)
};

const ms_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`peranti ini`)
};

const bn_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই যন্ত্র`)
};

const zh_tw2_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這台裝置`)
};

const zh_hk2_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這台裝置`)
};

const ur_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ آلہ`)
};

const fa_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`همین دستگاه`)
};

const sw_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kifaa hiki`)
};

const nl_this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dit apparaat`)
};

/**
* | output |
* | --- |
* | "this device" |
*
* @param {This_DeviceInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const this_device = /** @type {((inputs?: This_DeviceInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_DeviceInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_this_device(inputs)
	if (locale === "ja") return ja_this_device(inputs)
	if (locale === "zh") return zh_this_device(inputs)
	if (locale === "es") return es_this_device(inputs)
	if (locale === "pt") return pt_this_device(inputs)
	if (locale === "id") return id_this_device(inputs)
	if (locale === "fr") return fr_this_device(inputs)
	if (locale === "tl") return tl_this_device(inputs)
	if (locale === "vi") return vi_this_device(inputs)
	if (locale === "ko") return ko_this_device(inputs)
	if (locale === "de") return de_this_device(inputs)
	if (locale === "ru") return ru_this_device(inputs)
	if (locale === "tr") return tr_this_device(inputs)
	if (locale === "it") return it_this_device(inputs)
	if (locale === "pl") return pl_this_device(inputs)
	if (locale === "uk") return uk_this_device(inputs)
	if (locale === "hi") return hi_this_device(inputs)
	if (locale === "ar") return ar_this_device(inputs)
	if (locale === "ms") return ms_this_device(inputs)
	if (locale === "bn") return bn_this_device(inputs)
	if (locale === "zh-TW") return zh_tw2_this_device(inputs)
	if (locale === "zh-HK") return zh_hk2_this_device(inputs)
	if (locale === "ur") return ur_this_device(inputs)
	if (locale === "fa") return fa_this_device(inputs)
	if (locale === "sw") return sw_this_device(inputs)
	if (locale === "nl") return nl_this_device(inputs)
	return en_this_device(inputs)
});